import { DayOfWeek } from '../enums';
import { TimeBlock } from '../models';

export const DEFAULT_RECEIPT_TEMPLATE = 'DEFAULT';

export const SELECT_ALL = 'SELECT_ALL';

export const DEFAULT_ONLINE_STORE_OPEN_TIME = '07:00';

export const DEFAULT_ONLINE_STORE_CLOSE_TIME = '23:59';

export const DEFAULT_ONLINE_STORE_ACCENT_COLOR = '#2684fc';

export const DEFAULT_ONLINE_STORE_RANGE_TIME: TimeBlock[] = [
  {
    isActive: true,
    day: DayOfWeek.SUNDAY,
    timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
  },
  {
    isActive: true,
    day: DayOfWeek.MONDAY,
    timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
  },
  {
    isActive: true,
    day: DayOfWeek.TUESDAY,
    timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
  },
  {
    isActive: true,
    day: DayOfWeek.WEDNESDAY,
    timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
  },
  {
    isActive: true,
    day: DayOfWeek.THURSDAY,
    timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
  },
  {
    isActive: true,
    day: DayOfWeek.FRIDAY,
    timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
  },
  {
    isActive: true,
    day: DayOfWeek.SATURDAY,
    timeSlots: [{ startTime: '07:00', endTime: '23:59' }],
  },
];
